export enum EWRFees {
    PORT_FEE = 'Port Fee',
    EXAM_FEE = 'Hdlg&Mnfst Fee',
}
